import * as marietta from '../..';
import ItemControllerRoomMansion from './ItemControllerRoomMansion';

export default class ItemControllerRoomDetached extends ItemControllerRoomMansion {
  /**
  * コンストラクタ
  */
  constructor(_target: marietta.webcad.item.MonicaObject) {
    super(_target);
    this.reInitController();
    marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
  }

  /**
    * 矢印位置を合わせる
    * */
  setArrowPositions() {
    // 頂点作成
    const points: number = this.target.itemInfo.dotList.length;
    let cornerPicker: marietta.webcad.control.parts.RoomCornerDragger;
    let movePicker: marietta.webcad.control.parts.RoomMovePickerWall;
    let i: number;
    let point1: marietta.core.Point;
    let point2: marietta.core.Point;
    let angle: number;
    let pRadian: number;
    for (i = 0; i < this.movePickerWallList.length; i += 1) {
      movePicker = this.movePickerWallList[i];
      movePicker.firstDot = this.target.itemInfo.dotList[i].point;
      movePicker.movePickerLength = this.movePickerWallList.length;
      if (i === this.target.itemInfo.dotList.length - 1) {
        movePicker.secondDot = this.target.itemInfo.dotList[0].point;
      } else {
        movePicker.secondDot = this.target.itemInfo.dotList[i + 1].point;
      }
      point1 = new marietta.core.Point(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);
      point2 = (i === points - 1) ? new marietta.core.Point(this.target.itemInfo.dotList[0].x, this.target.itemInfo.dotList[0].y) : new marietta.core.Point(this.target.itemInfo.dotList[i + 1].x, this.target.itemInfo.dotList[i + 1].y);
      // 角度
      pRadian = Math.atan2((point1.x - point2.x), (point1.y - point2.y));
      angle = pRadian / (Math.PI / 180);
      movePicker.rotate(-angle);
    }
    for (i = 0; i < this.cornerPickerList.length; i += 1) {
      cornerPicker = this.cornerPickerList[i];
      // cornerPicker.cornerPickerLength = this.cornerPickerList.length;
      cornerPicker.move(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);
    }
  }
}
